import type { AssessmentTest } from '@entities/assessment'

import { questions as questionsMath } from '../questions/math/grade-k4'
import { questions as questionsEla } from '../questions/ela/grade-k4'
import { questionsTest as questionsElaTest } from '../questions/ela/grade-k4-test'

export const configK4: AssessmentTest = {
  title: 'Grade 4 math assessment',
  quizTitle: 'Math assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Math check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsMath,
}

export const configK4Ela: AssessmentTest = {
  title: 'Grade 4<br>reading assessment',
  quizTitle: 'Reading assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Comprehension check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsEla,
}

export const configK4ElaTest: AssessmentTest = {
  title: 'Grade 4<br>reading assessment',
  quizTitle: 'Reading assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Comprehension check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsElaTest,
}
